"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericCashBalanceFeedHandler = exports.mapCsvToBorrowerCashBalancesFeed = void 0;
const _ = __importStar(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
// standard borrower cash balance feed map
const mapCsvToBorrowerCashBalancesFeed = ({ borrowerId, csvArray, reportingDate, fileVersion, creditFacilityId, }) => {
    const dbRows = _.map(csvArray, (row) => {
        let conversionRate = 1; // default to 1
        if (row.conversion_rate !== undefined) {
            conversionRate = Number(row.conversion_rate);
        }
        // NOTE: we only reference the balance and balance_type columns from the csv file.
        // TODO: make a tape-builder receipe for this and remove hard code cash balance mapping functions.
        const borrowerCashBalanceRecord = {
            id: (0, uuid_1.v4)(),
            borrowerId,
            creditFacilityId,
            reportingDate,
            borrowerAccountType: row.balance_type,
            accountNumber: row.account_number ?? null,
            conversionRate,
            balance: Number(row.balance),
            fileVersion,
        };
        return borrowerCashBalanceRecord;
    });
    return _.map(dbRows, (row) => _.mapValues(row, common_1.utils.cleanStrForDb));
};
exports.mapCsvToBorrowerCashBalancesFeed = mapCsvToBorrowerCashBalancesFeed;
const genericCashBalanceFeedHandler = ({ borrowerId, csvArray, reportingDate, fileVersion, creditFacilityId, }) => {
    return (0, exports.mapCsvToBorrowerCashBalancesFeed)({
        borrowerId,
        csvArray,
        reportingDate,
        fileVersion,
        creditFacilityId,
    });
};
exports.genericCashBalanceFeedHandler = genericCashBalanceFeedHandler;
//# sourceMappingURL=mapCsvToBorrowerCashBalancesFeed.js.map